import { IDatepickerValue, IPeriod } from '@xenial-ux/xux-datepicker/types';

export enum CalendarTypeModel {
    FISC = 'FISC',
    SINGLE_DATE = 'SINGLE_DATE',
    PYRL = 'PYRL',
    INV = 'INV',
    SCHD = 'SCHD',
    CUSTOM = 'CUSTOM',
    XCAT = 'XCAT',
    NONE = 'NONE',
}

export enum PortalCalendarTypeModel {
    FISC = 'fiscal',
    PYRL = 'payroll',
    INV = 'inventory',
    XCAT = 'suite_catering',
}

export interface CalendarDateObject {
    inputCalendarValue: IDatepickerValue;
    calendars: IPeriod[];
    businessDate: string;
    source: string;
    hide?: boolean;
}
